// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer_bb5Dd","ui_mask":"ui_mask_AF8ba"};